import { CompetitionsMatchCardSchema } from './CompetitionsMatchCard.styles';

export const competitionsMatchCardStyles: CompetitionsMatchCardSchema = {
  vsBoxWrapper: {
    position: 'relative',
    p: '1',
  },
  vsDivider: {
    opacity: '1',
    ml: '5',
    bg: 'rgba(0, 0, 0, 0.25)',
    h: '1px',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.1)',
    borderBottomWidth: '0',
  },
  absoluteCenter: {
    mx: '2',
    left: '2',
    ml: '1px',
    fontWeight: 'normal',
    color: 'alpha.400',
    fontFamily: 'accent',
    fontSize: 'sm',
  },
  matchCardOverride: {
    mb: '2',
  },
  propositionButtonOverride: {
    w: '100%',
  },
  gridItem: {
    w: '100%',
  },
  flexWrapper: {
    alignItems: 'center',
  },
  flexText: {
    as: 'span',
    flex: '1',
    textAlign: 'left',
    fontWeight: 'normal',
    fontFamily: 'Staatliches',
    fontSize: 'sm',
    color: 'white',
  },
  gridWrapper: {
    gap: 2,
  },
  propositionButtonOverrideSecondary: {
    w: ['50px', '100px'],
    px: ['0', null, 'inherit'],
  },
  gridItemTextNoProposition: {
    w: ['50px', '100px'],
    h: 'full',
    minH: '10',
    textAlign: 'center',
    color: 'white',
    fontFamily: 'Staatliches',
    textShadow: '0px 2px 3px rgba(0, 0, 0, 0.30)',
    fontWeight: 'normal',
    fontSize: 'sm',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'base',
    border: '2px',
    borderColor: 'blackAlpha.500',
  },
  flexAwayTeam: {
    alignItems: 'center',
  },
  flexAwayTeamText: {
    flex: '1',
    textAlign: 'left',
    fontFamily: 'Staatliches',
    fontWeight: 'normal',
    fontSize: 'sm',
    color: 'white',
  },
};
